import { 
  Shield, 
  Users, 
  Activity, 
  Database,
  AlertTriangle,
  TrendingUp
} from 'lucide-react'

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-purple-900 to-slate-900 pt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center mb-8">
          <Shield className="w-10 h-10 mr-3 text-red-400" />
          <div>
            <h1 className="text-4xl font-bold text-white">Admin Dashboard</h1>
            <p className="text-gray-400">System monitoring and administration</p>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <div className="flex items-center justify-between mb-4">
              <Users className="w-8 h-8 text-blue-400" />
              <TrendingUp className="w-4 h-4 text-green-400" />
            </div>
            <div className="text-3xl font-bold text-white mb-2">1,247</div>
            <div className="text-gray-400">Active Players</div>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <div className="flex items-center justify-between mb-4">
              <Activity className="w-8 h-8 text-green-400" />
              <TrendingUp className="w-4 h-4 text-green-400" />
            </div>
            <div className="text-3xl font-bold text-white mb-2">99.8%</div>
            <div className="text-gray-400">System Uptime</div>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <div className="flex items-center justify-between mb-4">
              <Database className="w-8 h-8 text-purple-400" />
              <TrendingUp className="w-4 h-4 text-green-400" />
            </div>
            <div className="text-3xl font-bold text-white mb-2">2.4TB</div>
            <div className="text-gray-400">Database Size</div>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <div className="flex items-center justify-between mb-4">
              <AlertTriangle className="w-8 h-8 text-orange-400" />
              <div className="text-sm text-orange-400">3 Active</div>
            </div>
            <div className="text-3xl font-bold text-white mb-2">12</div>
            <div className="text-gray-400">System Alerts</div>
          </div>
        </div>

        {/* Admin Actions */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <h3 className="text-xl font-bold text-white mb-4">Quick Actions</h3>
            <div className="space-y-3">
              <button className="w-full text-left p-3 bg-slate-700/50 hover:bg-slate-600/50 rounded-lg transition-colors">
                <div className="font-medium text-white">User Management</div>
                <div className="text-sm text-gray-400">Manage player accounts and permissions</div>
              </button>
              <button className="w-full text-left p-3 bg-slate-700/50 hover:bg-slate-600/50 rounded-lg transition-colors">
                <div className="font-medium text-white">System Monitoring</div>
                <div className="text-sm text-gray-400">View server performance and logs</div>
              </button>
              <button className="w-full text-left p-3 bg-slate-700/50 hover:bg-slate-600/50 rounded-lg transition-colors">
                <div className="font-medium text-white">Game Balance</div>
                <div className="text-sm text-gray-400">Adjust game parameters and settings</div>
              </button>
            </div>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm rounded-lg p-6 border border-white/10">
            <h3 className="text-xl font-bold text-white mb-4">Recent Activity</h3>
            <div className="space-y-3">
              <div className="p-3 bg-slate-700/30 rounded-lg">
                <div className="text-sm text-white">Player "SpaceCommander" reported for griefing</div>
                <div className="text-xs text-gray-400">2 minutes ago</div>
              </div>
              <div className="p-3 bg-slate-700/30 rounded-lg">
                <div className="text-sm text-white">Server maintenance scheduled</div>
                <div className="text-xs text-gray-400">15 minutes ago</div>
              </div>
              <div className="p-3 bg-slate-700/30 rounded-lg">
                <div className="text-sm text-white">New player registration spike detected</div>
                <div className="text-xs text-gray-400">1 hour ago</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard